import { render, staticRenderFns } from "./SaleTaxUpdate.vue?vue&type=template&id=713e0ae2&"
import script from "./SaleTaxUpdate.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports